// extracted by mini-css-extract-plugin
module.exports = {"tableLabel":"e_or","container":"e_pr","hidden":"e_qr"};